// extracted by mini-css-extract-plugin
export default {"inset":"Inset_inset__H3p6A","inline":"Inset_inline__rJFO9"};